<template>
  <div class="container commonDetail">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/Mine/Monitor' }"
        >监测列表</el-breadcrumb-item
      >
      <el-breadcrumb-item>监测详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="commonWhiteBg" v-if="orderInfo">
      <div class="topSteps MonitorSteps">
        <el-steps :active="orderInfo.status != '10'?1:0 ">
          <el-step title="支付">
            <div slot="description">
              {{ orderInfo.status == '10' ? "等待支付" :orderInfo.createTimeText }}
            </div>
            <a-icon v-if="orderInfo.status=='10'" slot="icon" type="redo" />
            <a-icon v-else slot="icon" type="check" />
          </el-step>
          <el-step title="监测">
            <template v-if="orderInfo.status == '21'">
              <div slot="description">持续监测中，至{{orderInfo.endTimeText}}停止</div>
              <a-icon slot="icon" type="exclamation" />
            </template>
            <template v-else-if="orderInfo.status == '11'">
              <div slot="description">持续监测中，至{{orderInfo.endTimeText}}停止</div>
              <a-icon slot="icon" type="redo" />
            </template>
          </el-step>
        </el-steps>
        <div class="rightMain">
          <template v-if="orderInfo.status == '10'">
            <div>
              <span class="label"> 订单编号：</span>
              <span class="value"> {{ orderNo }} </span>
            </div>
            <div>
              <span class="label"> 支付方式：</span>
              <span class="value">
                {{ orderInfo.paymodeText }}（{{
                  orderInfo.orderAmount
                }}元）</span
              >
            </div>
            <div class="btnWrap">
              <el-button type="primary" size="mini" @click="onGoPay">立即支付</el-button>
            </div>
          </template>
          <template v-if="orderInfo.status != '10'">
            <div class="monitorTime">
              <span class="label"> 预计监测时长： </span>
              <span class="value">
                <strong> {{ orderInfo.duration.day }} </strong> 天
                <strong> {{ orderInfo.duration.hour }} </strong> 小时
                <strong> {{ orderInfo.duration.min }} </strong> 分钟
              </span>
            </div>

            <div class="btnWrap">
              <el-button type="primary" size="mini" @click="$router.push({ path: '/Monitor/Result', query: {'orderNo': orderNo,'orderId': orderInfo.id} })">查看全部结果</el-button>
              <el-button type="primary" size="mini" @click="$router.push({ path: '/ObtainEvidence/InputForm' })" style="margin-left: 0;">手动取证</el-button>
            </div>
          </template>
        </div>
      </div>
      <div class="currentMonitor" v-if="stepIdx == 1">
        <div class="commonTitle mt32">当前监测结果</div>
        <div class="chartShow">
          <div class="inner">
            <img
              src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/chartBg.png"
            />
            <p class="numBlock block1">
              已监测时长
              <i class="num">
                <!-- <ICountUp :delay="1000" :endVal="orderInfo.duration.costMin*1" /> -->
                <ICountUp :delay="1000" :endVal="orderInfo.timeDiff" />
              </i>
              分钟
            </p>
            <p class="numBlock block2">
              监测范围
              <i class="num"> <ICountUp :delay="1000" :endVal="orderInfo.detectPlatform.length" /> </i> 个
            </p>
            <p class="numBlock block3">
              已监测数据
              <i class="num"> <ICountUp :delay="1000" :endVal="monitorNum.detectCount" /> </i> 条
            </p>
            <p class="numBlock block4">
              发现传播数据
              <i class="num"> <ICountUp :delay="1000" :endVal="monitorNum.obtainCount" /> </i> 条
            </p>
          </div>
        </div>
        <div class="smallTitle">
          <strong>监测结果</strong>
          <span class="desc"> 发现 <i class="num">{{monitorNum.obtainItems.length}}</i> 个范围有传播数据 </span>
        </div>
        <el-table :data="monitorNum.obtainItems" style="width: 100%">
          <el-table-column prop="name" label="范围">
            <template slot-scope="scope">
              <div class="logoRow">
                <!-- <img :src="scope.row.logo" /> -->
                <span class="name">{{ scope.row.platformText }} </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="num1" label="传播数量">
            <template slot-scope="scope">
              <div class="bigNum">{{ scope.row.totalCount }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="num2" label="监测数量">
            <template slot-scope="scope">
              <div class="bigNum" v-if="scope.row.detectNum">{{ scope.row.detectNum }}</div>
              <div class="bigNum" v-else>0</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="smallTitle flexTitle" v-if="orderInfo.status!='10'">
          <strong>部分监测结果</strong>
          <router-link :to="{ path: '/Monitor/Result', query: {'orderNo': orderNo,'orderId': orderInfo.id} }">
            <span>查看全部结果</span>
            <a-icon type="right" />
          </router-link>
        </div>
        <!-- <ul class="picList">
          <li v-for="(item, index) in picList" :key="index">
            <div class="img"><img :src="item.img" /></div>
            <div class="down">
              <div class="name">{{ item.name }}</div>
              <div class="webSite">{{ item.webSite }}</div>
              <div class="btnWrap">
                <router-link
                  :to="{ path: '/ObtainEvidence/InputForm' }"
                ></router-link>
                <el-button type="primary"> 取证 </el-button>
              </div>
            </div>
          </li>
        </ul> -->
        <ul class="picList">
          <li
            v-for="(item,index) in monitorInfo.list"
            :key="index"
          >
            <div class="listTop">
              <div class="left">监测范围：{{item.platformText}}</div>
              <div class="right">相似度：{{item.obtainResult.similarity}}</div>
            </div>
            <div class="img"> 
              <!-- <img :src="item.items[0].downloadUrl"> -->
              <el-image :src="item.items[0].downloadUrl"
                :preview-src-list="[item.items[0].downloadUrl]" alt="">
              </el-image>
            </div>
            <div class="down">
              <div class="name">名称：{{item.subject}}</div>
              <div class="webSite">链接：{{item.obtainResult.url}} </div>
              <div class="btnWrap">
                <!-- <router-link :to="{path:'/ObtainEvidence/InputForm'}"></router-link> -->
                <!-- <el-button type="primary"> 取证 </el-button> -->
                <el-button type="primary" size="mini" @click="openViewer">查看快照</el-button>
                <el-image-viewer
                  v-if="isOpenViewer"
                  :on-close="closeViewer"
                  :url-list="[item.items[0].downloadUrl,item.items[0].downloadUrl]"
                />
                <el-button type="primary" size="mini"><a :href="item.obtainResult.url" target="_blank">打开链接</a></el-button>
                <el-button type="primary" size="mini" @click="toObtainEvidence(item.orderNo)">一键取证</el-button>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="commonTitle mt32">监测信息</div>
      <div>
        <el-form ref="form" label-width="140px">
          <el-form-item label="订单编号" prop="orderNo">
            {{ orderNo }}
          </el-form-item>
          <el-form-item label="支付方式" prop="paymodeText">
            {{ orderInfo.paymodeText }}
          </el-form-item>
          <el-form-item label="支付金额(元)" prop="price">
            {{ orderInfo.orderAmount }}
          </el-form-item>
          <el-form-item label="存证文件" prop="evidenceFile">
            <div class="nameRow">
              <span v-for="(file, index) in orderInfo.item" :key="index"
                >{{ file.sourceName }} &nbsp;</span
              >
              <router-link
                :to="{
                  path: '/ExistingEvidence/FileList',
                  query: { orderNo, bizType: 'detect' },
                }"
              >
                查看存证文件
              </router-link>
            </div>
          </el-form-item>
          <el-form-item label="监测名称" prop="name">
            <div class="nameRow">
              {{ orderInfo.subject }}
              <router-link  v-if="orderInfo.status!='10'" :to="{ path: '/Monitor/Result', query: {'orderNo': orderNo,'orderId': orderInfo.id} }">
                查看监测结果
              </router-link>
            </div>
          </el-form-item>
          <el-form-item label="监测关键词" prop="keyWords">
            {{ orderInfo.keyword.join(",") }}
          </el-form-item>

          <el-form-item label="监测范围" prop="platform">
            <multiple-select
              v-model="orderInfo.detectPlatform"
              :isResultView="true"
              :listOpt="constants.platform"
            ></multiple-select>
          </el-form-item>
          <el-form-item label="监测时长" prop="time">
            {{ orderInfo.timeText }}
          </el-form-item>
          <el-form-item label="计划开始时间" prop="createTimeText">
            {{ orderInfo.createTimeText }}
          </el-form-item>
          <el-form-item label="计划结束时间" prop="endTimeText">
            {{ orderInfo.endTimeText }}
          </el-form-item>
        </el-form>
      </div>
    </div>
       <pay-dialog ref="payDialog" @close="onSetPayDialogClose"></pay-dialog>
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import {
  queryDetectOrder,
  queryPaymentOrderByOutBizNp,
  paymentDetectOrder,
  queryMonitorNum,
  queryMonitor,
  goObtain
} from "@/api/EvidenceService";
import constants from "@/utils/constants";
import multipleSelect from "../../../components/form/multipleSelect";
import PayDialog from "@/views/multipleService/components/PayDialog";
import ICountUp from "vue-countup-v2";
export default {
  name: "MonitorDetail",
  components: { ElImageViewer,multipleSelect, ICountUp,PayDialog },
  data() {
    return {
      constants,
      orderNo: this.$route.query.orderNo,
      orderInfo: null,
      paymentInfo: {},
      stepIdx: 1, // 0 带支付, 1处理中,
      platformOpt: [
        {
          value: "1",
          label: "XXX平台1",
        },
        {
          value: "2",
          label: "XXX平台2",
        },
        {
          value: "3",
          label: "XXX平台3",
        },
      ],
      form: {
        orderNo: "217902790789809",
        payTypeDesc: "会员次数",
        price: "10",
        evidenceFile: "作品名称123",
        keyWords: "关键词1,关键词2,关键词3",
        name: "作品登记名称123",
        time: "0天0小时45分钟",
        timeStart: "2021.01.01 12:50",
        timeEnd: "2021.01.01 12:50",
        payStyle: 1,
        platform: ["1", "2", "3"],
      },
      tableData: [
        {
          name: "百度",
          num1: "0",
          num2: "0",
          logo:
            "https://baikewh.oss-cn-hangzhou.aliyuncs.com/static/ipchain/baidu.png",
        },
        {
          name: "百度",
          num1: "0",
          num2: "0",
          logo:
            "https://baikewh.oss-cn-hangzhou.aliyuncs.com/static/ipchain/baidu.png",
        },
      ],
      picList: [
        // {
        //   img: 'https://baikewh.oss-cn-hangzhou.aliyuncs.com/static/ipchain/result1.png',
        //   name: '三体-刘慈欣-在线阅读',
        //   webSite: 'http://www.shizongzui.cc/santi/'
        // },
        // {
        //   img: 'https://baikewh.oss-cn-hangzhou.aliyuncs.com/static/ipchain/result2.png',
        //   name: '三体-刘慈欣-在线阅读',
        //   webSite: 'https://www.kunnu.com/santi/'
        // },
        // {
        //   img: 'https://baikewh.oss-cn-hangzhou.aliyuncs.com/static/ipchain/result3.png',
        //   name: '三体-最新章节-免费阅读',
        //   webSite: 'https://www.znlzd.com/bqg/1403/'
        // }
      ],
      isOpenViewer: false,
      monitorInfo: {},

      monitorNum: {
        detectCount: 0,
        items: [],
        obtainCount: 0,
        obtainItems: [],
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    getStep(status) {
      let step = 0;
      if (status == "10") {
        step = 0;
      } else if (status * 1 < 21) {
        step = 1;
      } else {
        step = 2;
      }
      return step;
    },
    loadData() {
      queryDetectOrder(this.orderNo).then(({ data }) => {
        // console.log('555555555555',data);
        this.orderInfo = data;
        this.orderInfo.paymodeText = constants.paymode[this.orderInfo.paymode];
        this.orderInfo.endTimeText = this.dayjs(
          this.orderInfo.endTime * 1000
        ).format("YYYY-MM-DD HH:mm:ss ");
        this.orderInfo.step = this.getStep(this.orderInfo.status);

        this.orderInfo.createTimeText = this.dayjs(
          this.orderInfo.createTime * 1000
        ).format("YYYY-MM-DD HH:mm:ss ");
        this.orderInfo.updateTimeText = this.dayjs(
          this.orderInfo.updateTime * 1000
        ).format("YYYY-MM-DD HH:mm:ss ");

        // 已经检测时长(计算已经检测 分钟)
        var dateDiff = new Date().getTime()/1000 - this.orderInfo.createTime; //时间差的毫秒数
        var minutes = Math.floor(dateDiff / 60); //计算相差分钟数
        this.orderInfo.timeDiff = minutes;
        // 已经监测时长转换
        var dateDiff2 = new Date().getTime()/1000 - this.orderInfo.createTime; //时间差的毫秒数
        var dayDiff2 = Math.floor(dateDiff2 / (24 * 3600)); //计算出相差天数
        var leave1 = dateDiff2 % (24 * 3600); //计算天数后剩余的毫秒数
        var hours = Math.floor(leave1 / 3600); //计算出小时数
        //计算相差分钟数
        var leave2 = leave1 % 3600; //计算小时数后剩余的毫秒数
        var minutes2 = Math.floor(leave2 / 60); //计算相差分钟数
        // console.log("监测时长转换" + dayDiff2 + "天" + hours + "小时" + minutes2 + "分钟" );
        this.orderInfo.timeText = dayDiff2 + "天" + hours + "小时" + minutes2 + "分钟";

        //计算时间间隔
        let duration = {
          day: "",
          hour: "",
          min: "",
          costMin: "0",
        };
        let timeLast =
          this.orderInfo.endTime * 1 - this.orderInfo.createTime * 1;
        // console.log(timeLast);
        duration.day = Math.floor(timeLast / (60 * 60 * 24));
        duration.hour = Math.floor(
          (timeLast - duration.day * 60 * 60 * 24) / (60 * 60)
        );
        duration.min = Math.floor(
          (timeLast - duration.day * 60 * 60 * 24 - duration.hour * 60 * 60) /
            60
        );
        this.orderInfo.duration = duration;

        if (this.orderInfo.status != "10") {
          queryPaymentOrderByOutBizNp(this.orderNo, "4").then(({ data }) => {
            this.paymentInfo = data;
            this.orderInfo.duration.costMin = Math.ceil(
              (Math.round(Date.now() / 1000) - this.orderInfo.paymentInfo * 1) /
                60
            );
            this.paymentInfo.payTimeText = this.dayjs(
              this.paymentInfo.updateTime * 1000
            ).format("YYYY-MM-DD HH:mm:ss ");
          });
        }

        // 获取监测结果数量
        queryMonitorNum(this.orderInfo.id).then(({data})=>{
          console.log('获取数量：====',data);
          this.monitorNum = data;
          this.monitorNum.detectCount = Number(data.detectCount);
          this.monitorNum.obtainCount = Number(data.obtainCount);
          for(let i in this.monitorNum.obtainItems){
            this.monitorNum.obtainItems[i].platformText = this.constants.platform[this.monitorNum.obtainItems[i].platformId].label;
            for(let n in this.monitorNum. detectItems){
              this.monitorNum. detectItems[n].platformText = this.constants.platform[this.monitorNum. detectItems[n].platformId].label;
              // console.log(this.monitorNum. detectItems[i].platformText);
              if(this.monitorNum.obtainItems[i].platformId = this.monitorNum. detectItems[n].platformId){
                this.monitorNum.obtainItems[i].detectNum = this.monitorNum. detectItems[i].totalCount;
              }
            }
          }
          console.log("获取整合的监测结果列表：",this.monitorNum.obtainItems);
        })

        // 获取检测结果详情列表
        queryMonitor(1,3,this.orderInfo.id).then(({data})=>{
          // console.log('获取检测结果:',data);
          this.monitorInfo = data;
          for(let i in this.monitorInfo.list){
            this.monitorInfo.list[i].platformText = this.constants.platform[this.monitorInfo.list[i].platformId].label;
          }
        })

      });
      
    }, onGoPay() {
      let that = this;
      paymentDetectOrder(that.orderNo).then(({data})=>{
            that.$refs.payDialog.showDialog(data);
            that.isPayDialogVisible = true;
      })
    
    },
    onSetPayDialogClose(result) {
      console.log(result);
      if (result) {
        this.loadData();
      }
    },


    // 查看快照
    openViewer() {
      this.isOpenViewer = true
    },
    // 关闭图片预览
    closeViewer() {
      this.isOpenViewer = false
    },

    // 一键取证
    toObtainEvidence(orderNo){
        // console.log(orderNo);
        goObtain(orderNo).then(({data})=>{
          // console.log('一键取证:',data);
        })
    },
  },
};
</script>

<style lang='scss' scoped>
@import "../../../assets/css/inputForm.scss";
.picList{max-height: 390px;overflow: hidden;}
.picList li{margin-bottom: 20px;box-shadow: 0 0 16px rgba(0, 109, 117, 0.1);border-radius: 5px;}
.picList > li:nth-child(3n+2){margin-bottom: 20px;}
.picList .listTop{height: 40px;padding: 0 16px;line-height: 40px;}
.picList .listTop .left{float: left;}
.picList .listTop .right{float: right;}
.picList li .name,.picList li .webSite{overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-top: 0;}
.picList .btnWrap{display: flex;justify-content: space-between;align-items: center;}
.el-button + .el-button a{color: #fff;border: none;text-decoration: none;}
</style>
